if (typeof window.renderHelperCart !== "function") {
  window.renderHelperCart = (text) => {
    const sectionInnerHTML = new DOMParser().parseFromString(text, "text/html");
    const cartFormInnerHTML = sectionInnerHTML.getElementById("AjaxCartForm").innerHTML;
    const cartSubtotalInnerHTML = sectionInnerHTML.getElementById("AjaxCartSubtotal").innerHTML;

    const cartItems = document.getElementById("AjaxCartForm");
    cartItems.innerHTML = cartFormInnerHTML;
    cartItems.ajaxifyCartItems();

    const cartCount = cartItems.querySelector("[data-cart-count]");
    if (cartCount) {
      document.querySelectorAll("[data-header-cart-count]").forEach((elm) => {
        elm.textContent = cartCount.textContent;
      });
    }

    document.getElementById("AjaxCartSubtotal").innerHTML = cartSubtotalInnerHTML;

    // Re-announce count and total through the same path as a quantity change.
    fetch("/cart.js")
      .then((response) => response.json())
      .then((cartData) => {
        const cartForm = document.querySelector("cart-form");
        if (!cartForm) return;
        cartForm.updateCartCountElements(cartData);
        cartForm.updateCartTotalElements(cartData);
        cartForm.updateCartTextElements(cartData);
        cartForm.updateHeaderCartAnnouncement(cartData);
      })
      .catch(() => {});

    return sectionInnerHTML;
  };
}

if (window.KROWN && KROWN.functions && typeof KROWN.functions.dispatchStandardEvent !== "function") {
  KROWN.functions.dispatchStandardEvent = (className, target, detail) => {
    const SE = window.Shopify && window.Shopify.StandardEvents;
    if (!SE || typeof SE[className] !== "function") return;
    try {
      (target || document).dispatchEvent(new SE[className](detail));
    } catch (error) {
      console.warn(`standard-events: ${className}`, error);
    }
  };
}

if (typeof CartForm !== "function") {
  class CartForm extends HTMLElement {
    constructor() {
      super();
      this.ajaxifyCartItems();

      document.addEventListener("cart-updated", (event) => {
        if (event.detail?.source !== "cart-form") {
          this.initializeAllQuantitySelectors();
        }
      });
    }

    ajaxifyCartItems() {
      this.form = this.querySelector("form");
      if (!this.form) return;

      this.querySelectorAll("[data-js-cart-item]").forEach((item) => {
        const remove = item.querySelector(
          ".remove, .cart-item__remove, .br-cart-item__remove"
        );
        if (remove) {
          remove.dataset.href =
            remove.getAttribute("href") || remove.dataset.href;
          remove.setAttribute("href", "");
          remove.addEventListener("click", (e) => {
            e.preventDefault();
            this.updateCartQty(item, 0);
          });
        }
      });
    }

    initializeAllQuantitySelectors() {
      const quantitySelectors = this.querySelectorAll("cart-product-quantity");
      quantitySelectors.forEach((selector) => {
        if (
          selector.input &&
          selector.decreaseButton &&
          selector.increaseButton
        ) {
          if (typeof selector.init === "function" && !selector.initialized) {
            selector.init();
            selector.initialized = true;
          }
        }
      });
    }

    updateCartQty(item, newQty) {
      return new Promise((resolve, reject) => {
        let alert = null;

        const itemId = item.dataset.id;
        const itemIndex = parseInt(item.dataset.line);

        item.classList.add("item-updating");

        const announcer = document.querySelector(".cart-update-announcement");
        if (announcer) {
          announcer.textContent = KROWN.settings.locales.cart_updating || "Updating cart...";
        }

        const body = JSON.stringify({
          line: itemIndex,
          quantity: newQty,
        });

        fetch(KROWN.settings.routes.cart_change_url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/javascript",
          },
          body,
        })
          .then((response) => response.json())
          .then((cartData) => {
            // /cart/change.js returns the updated cart directly — use it without
            // a second /cart.js fetch to avoid stale-data races (count staying
            // wrong, quantity input bouncing back after an optimistic update).
            if (cartData.status == 422) {
              alert = document.createElement("span");
              alert.classList.add("alert", "alert--error");
              alert.setAttribute("role", "alert");
              if (typeof cartData.description === "string") {
                alert.textContent = cartData.description;
              } else {
                alert.textContent = cartData.message;
              }
              if (KROWN.functions.eventDispatcher) {
                KROWN.functions.eventDispatcher("krown:cart:error", {
                  error: alert.textContent,
                });
              }
              KROWN.functions.dispatchStandardEvent("CartErrorEvent", this, {
                error: alert.textContent,
              });
              reject(new Error(cartData.message));
              return;
            }

            // Update all cart count elements
            this.updateCartCountElements(cartData);

            // Update all cart total elements
            this.updateCartTotalElements(cartData);

            // Update cart text elements
            this.updateCartTextElements(cartData);

            // Update subtotal elements (both regular and BR versions)
            this.updateSubtotalElements(cartData);

            if (newQty === 0) {
              // Remove every copy of the line (page + drawer) — removing only the
              // clicked one left the other surface showing a line that is no
              // longer in the cart.
              const copies = this.itemsForKey(itemId);
              copies.forEach((copy) => {
                copy.style.height = copy.offsetHeight + "px";
              });
              setTimeout(() => {
                copies.forEach((copy) => {
                  copy.style.height = "0";
                  copy.style.opacity = "0";
                  copy.style.overflow = "hidden";
                });
                setTimeout(() => {
                  copies.forEach((copy) => copy.remove());
                  if (cartData.item_count === 0) {
                    window.refreshCart();
                  } else {
                    // After a deletion Shopify shifts all remaining line indexes
                    // (line 2 becomes line 1, etc.). Re-sync every DOM item's
                    // data-line from the server response so subsequent operations
                    // target the correct position. Without this, the next delete
                    // or quantity change hits the wrong line and the item appears
                    // to come back on page refresh.
                    document.querySelectorAll("[data-js-cart-item]").forEach((domItem) => {
                      const serverItem = cartData.items.find(
                        (ci) => ci.key === domItem.dataset.id
                      );
                      if (serverItem) {
                        domItem.dataset.line = cartData.items.indexOf(serverItem) + 1;
                      }
                    });
                  }
                }, 300);
              }, 10);
            } else {
              const itemData = cartData.items.find((i) => i.key === itemId);
              if (itemData) {
                // Server response is the source of truth: line price, compare-at
                // price and line discounts all get re-rendered together, and the
                // stored unit price is refreshed so the next optimistic update is
                // calculated from a current figure (quantity-break pricing).
                // Applied to every copy of the line (page + drawer).
                this.itemsForKey(itemId).forEach((copy) =>
                  this.renderLineItem(copy, itemData)
                );
              }
            }

            const event = new CustomEvent("cart-updated", {
              bubbles: true,
              detail: {
                source: "cart-form",
                itemId: itemId,
                newQty: newQty,
                cartData: cartData,
              },
            });
            document.dispatchEvent(event);

            if (announcer) {
              announcer.textContent = KROWN.settings.locales.cart_updated || "Cart updated";
              setTimeout(() => {
                announcer.textContent = "";
              }, 2000);
            }

            const updatedItem = cartData.items.find((i) => i.key === itemId);
            if (updatedItem && KROWN.functions.eventDispatcher) {
              KROWN.functions.eventDispatcher("krown:cart:update", {
                itemKey: updatedItem.key,
                itemQty: updatedItem.quantity,
                itemVariantId: updatedItem.variant_id,
                itemProductId: updatedItem.product_id,
              });
            }

            KROWN.functions.dispatchStandardEvent("CartLinesUpdateEvent", this, {
              action: newQty === 0 ? "remove" : "update",
              context: "cart",
              lines: [{ id: itemId, quantity: newQty }],
              promise: Promise.resolve({ cart: cartData }),
            });

            resolve(cartData);
          })
          .catch((e) => {
            let alert = document.createElement("span");
            alert.classList.add("alert", "alert--error");
            alert.textContent = KROWN.settings.locales.cart_general_error;
            this.form.prepend(alert);

            if (announcer) {
              announcer.textContent = KROWN.settings.locales.cart_error_updating || "Error updating cart";
              setTimeout(() => {
                announcer.textContent = "";
              }, 2000);
            }

            reject(e);
          })
          .finally(() => {
            item.classList.remove("item-updating");
          });
      });
    }

    updateCartCountElements(cartData) {
      const cartCountElements = document.querySelectorAll(
        "[data-header-cart-count], [data-cart-count]"
      );

      // Calculate total quantity (sum of all item quantities)
      const totalQuantity = cartData.items.reduce(
        (total, item) => total + item.quantity,
        0
      );

      cartCountElements.forEach((elm) => {
        // Use total quantity instead of item_count for better user experience
        elm.textContent = totalQuantity;
      });
    }

    updateCartTotalElements(cartData) {
      const cartTotalElements = document.querySelectorAll(
        "[data-header-cart-total], [data-cart-total]"
      );
      const formattedTotal = this._formatMoney(
        cartData.total_price,
        KROWN.settings.shop_money_format
      );
      cartTotalElements.forEach((elm) => {
        elm.textContent = formattedTotal;
      });
    }

    updateCartTextElements(cartData) {
      const cartTextElements = document.querySelectorAll("[data-cart-text]");
      const totalQuantity = cartData.items.reduce(
        (total, item) => total + item.quantity,
        0
      );

      cartTextElements.forEach((elm) => {
        elm.textContent =
          totalQuantity === 1
            ? (KROWN.settings.locales.cart_item_singular || "product in your cart")
            : (KROWN.settings.locales.cart_item_plural || "products in your cart");
      });
    }

    updateSubtotalElements(cartData) {
      const formattedTotal = this._formatMoney(
        cartData.total_price,
        KROWN.settings.shop_money_format
      );

      // Update regular subtotal
      const subtotalElement = document.getElementById("AjaxCartSubtotal");
      if (subtotalElement) {
        const subtotalPrice = subtotalElement.querySelector(
          ".cart-subtotal__price"
        );
        if (subtotalPrice) {
          subtotalPrice.textContent = formattedTotal;
        }
      }

      // Update BR cart subtotal elements
      const cartSubtotalElement = document.getElementById("CartSubTotal");
      if (cartSubtotalElement) {
        // The subtotal value is directly in the span element, not nested
        cartSubtotalElement.textContent = this._formatMoney(
          cartData.items_subtotal_price,
          KROWN.settings.shop_money_format
        );
      }

      // Update BR cart total, using the SAME formula cart-subtotal-br.liquid uses.
      // The shipping cost and threshold come from the markup so Liquid and JS can
      // never disagree (they used to: the JS omitted shipping entirely, so the
      // Total silently dropped by the shipping cost on the first quantity change).
      const cartTotalElement = document.getElementById("CartTotal");
      if (cartTotalElement) {
        const config = this._getShippingConfig();

        let calculatedTotal =
          cartData.items_subtotal_price - (cartData.total_discount || 0);

        if (!this._isFreeShippingEligible(cartData, config)) {
          calculatedTotal += config.shippingCost;
        }

        cartTotalElement.textContent = this._formatMoney(
          calculatedTotal,
          KROWN.settings.shop_money_format
        );
      }

      // Discount row: toggled rather than conditionally rendered, so a discount
      // that appears or disappears mid-session has somewhere to go.
      const discountRow = document.getElementById("CartDiscountRow");
      if (discountRow) {
        const discount = cartData.total_discount || 0;
        discountRow.hidden = discount <= 0;
        const discountValue = document.getElementById("CartDiscounts");
        if (discountValue) {
          discountValue.textContent =
            "-" + this._formatMoney(discount, KROWN.settings.shop_money_format);
        }
      }

      // Shipping row and progress bar depend on the same threshold — keep them in
      // step with the total, or crossing the threshold leaves them stale.
      this.updateShippingRow(cartData);
      this.updateProgressBar(cartData);
      this.updateHeaderCartAnnouncement(cartData);

      // Update BR cart quantity-price elements (quantity x unit price)
      this.updateQuantityPriceElements(cartData);

      // Sync quantity inputs across all cart templates
      this.syncQuantityInputs(cartData);
    }

    // Canonical hooks, present on both cart templates (page + drawer):
    //   item[data-unit-price]            per-unit price after line discounts
    //   item[data-compare-unit-price]    per-unit compare-at price (optional)
    //   [data-cart-item-price]           the line price element
    //   [data-cart-item-compare-price]   the strikethrough element (optional)
    // Legacy class selectors are kept as fallbacks for any surface not yet tagged.
    _priceEl(item) {
      return item.querySelector(
        "[data-cart-item-price], .item__price, .cart-item__price-current, .br-cart-item__price-current"
      );
    }

    _comparePriceEl(item) {
      return item.querySelector(
        "[data-cart-item-compare-price], .item__price--compare, .br-cart-item__price-compare"
      );
    }

    // The cart drawer is rendered on EVERY page (layout/theme.liquid), so on the
    // cart page the same line exists twice in the DOM with the same data-id.
    // Quantity was already synced across both copies, but prices were only ever
    // written to the copy that was clicked — so changing quantity in the drawer
    // left the page's price stale, and vice versa. Every price/removal update
    // must therefore apply to every copy of the line.
    itemsForKey(key) {
      return Array.from(
        document.querySelectorAll("[data-js-cart-item]")
      ).filter((el) => el.dataset.id === key);
    }

    // Repaint a line's prices from a quantity + unit prices. Used by both the
    // optimistic update (local guess) and the server response (truth).
    paintLinePrices(item, quantity, unitPrice, compareUnitPrice) {
      const priceEl = this._priceEl(item);
      if (priceEl && Number.isFinite(unitPrice)) {
        priceEl.textContent = this._formatMoney(
          unitPrice * quantity,
          KROWN.settings.shop_money_format
        );
      }

      // Compare-at price scales with quantity too — it used to be left at the
      // old quantity, showing two contradictory prices on a sale item.
      const compareEl = this._comparePriceEl(item);
      if (compareEl && Number.isFinite(compareUnitPrice) && compareUnitPrice > 0) {
        compareEl.textContent = this._formatMoney(
          compareUnitPrice * quantity,
          KROWN.settings.shop_money_format
        );
      }
    }

    // Full re-render of a line from the server's item payload.
    renderLineItem(item, itemData) {
      const unitPrice = itemData.final_price;
      const compareUnit = parseInt(item.dataset.compareUnitPrice);

      // Refresh the stored unit price: with quantity-break pricing the per-unit
      // figure changes, and a stale one makes every later optimistic guess wrong.
      item.dataset.unitPrice = unitPrice;
      item.dataset.qty = itemData.quantity;

      const priceEl = this._priceEl(item);
      if (priceEl) {
        priceEl.textContent = this._formatMoney(
          itemData.final_line_price,
          KROWN.settings.shop_money_format
        );
      }

      const compareEl = this._comparePriceEl(item);
      if (compareEl) {
        // original_line_price already accounts for quantity; fall back to the
        // stored compare-at unit price (cart.js does not return compare_at_price).
        const compareTotal =
          itemData.original_line_price > itemData.final_line_price
            ? itemData.original_line_price
            : Number.isFinite(compareUnit)
            ? compareUnit * itemData.quantity
            : null;
        if (compareTotal) {
          compareEl.textContent = this._formatMoney(
            compareTotal,
            KROWN.settings.shop_money_format
          );
        }
      }

      this.renderLineDiscounts(item, itemData);
    }

    // Line-level discounts scale with quantity, and can appear or disappear
    // entirely — rebuild the list rather than leaving stale amounts on screen.
    renderLineDiscounts(item, itemData) {
      const list = item.querySelector("[data-line-discounts], .br-cart-item__discounts");
      if (!list) return;

      const allocations = itemData.line_level_discount_allocations || [];
      if (!allocations.length) {
        list.hidden = true;
        list.innerHTML = "";
        return;
      }

      list.hidden = false;
      list.innerHTML = allocations
        .map((a) => {
          // Admin-entered text: escape it before it becomes markup
          const title = String(a.discount_application?.title || "").replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" })[c]);
          const amount = this._formatMoney(a.amount, KROWN.settings.shop_money_format);
          return (
            '<li class="br-cart-item__discount">' +
            '<span class="br-cart-item__discount-badge">' +
            (KROWN.settings.locales.cart_discount || "Discount") +
            "</span>" +
            '<span class="br-cart-item__discount-name">' + title + "</span>" +
            '<span class="br-cart-item__discount-amount">(-' + amount + ")</span>" +
            "</li>"
          );
        })
        .join("");
    }

    _getShippingConfig() {
      const details = document.getElementById("CartDetails");
      return {
        shippingCost: parseInt(details?.dataset.standardShippingCost) || 0,
        threshold: parseInt(details?.dataset.freeShippingThreshold) || 0,
        enabled: details?.dataset.freeShippingEnabled === "true",
      };
    }

    _isFreeShippingEligible(cartData, config) {
      if (!config.enabled || config.threshold <= 0) return false;
      return cartData.total_price >= config.threshold;
    }

    // Both shipping states are authored by Liquid (the free-shipping label is a
    // translation that may contain markup) — JS only toggles which one shows.
    updateShippingRow(cartData) {
      const row = document.getElementById("CartShipping");
      if (!row) return;

      const eligible = this._isFreeShippingEligible(
        cartData,
        this._getShippingConfig()
      );

      const paid = row.querySelector("[data-shipping-paid]");
      const free = row.querySelector("[data-shipping-free]");
      if (paid) paid.hidden = eligible;
      if (free) free.hidden = !eligible;

      const hidden = row.querySelector('input[name="attributes[shipping_discount]"]');
      if (hidden) hidden.value = eligible ? "free_shipping" : "";
    }

    updateProgressBar(cartData) {
      const wrapper = document.getElementById("cart-progress-wrapper");
      if (!wrapper) return;

      const threshold = parseInt(wrapper.dataset.threshold) || 0;
      if (threshold <= 0) return;

      const total = cartData.total_price;
      const percentage = Math.min(100, (total / threshold) * 100);
      const remaining = Math.max(0, threshold - total);
      const rounded = Math.round(percentage);

      const bar = wrapper.querySelector("#cart-progress-bar");
      if (bar) {
        bar.value = percentage;
        bar.setAttribute("aria-valuenow", rounded);
        bar.setAttribute(
          "aria-valuetext",
          remaining > 0
            ? `${rounded}% to free shipping threshold`
            : "Free shipping threshold reached"
        );
      }

      const visual = wrapper.querySelector(".cart-progress__visual");
      if (visual) visual.style.width = `${percentage}%`;

      wrapper.classList.toggle("cart-progress--full", percentage >= 100);
      wrapper.classList.toggle("cart-progress--partial", percentage < 100);

      // Status message sits in an aria-live region, so this also announces the
      // threshold being crossed to screen reader users.
      //
      // The two messages are merchant settings that may contain markup (the theme
      // defaults use <strong>FREE SHIPPING</strong>), so Liquid renders BOTH states
      // and this only toggles which one is shown and rewrites the money amount.
      // Writing the whole line here with textContent printed the tags literally.
      const preGoal = wrapper.querySelector("[data-progress-pre-goal]");
      const postGoal = wrapper.querySelector("[data-progress-post-goal]");

      if (preGoal) preGoal.hidden = remaining <= 0;
      if (postGoal) postGoal.hidden = remaining > 0;

      const amount = wrapper.querySelector("[data-remaining-amount]");
      if (amount && remaining > 0) {
        const format = (wrapper.dataset.currencyFormat || "").trim();
        amount.textContent = this._formatMoney(
          remaining,
          format || KROWN.settings.shop_money_format
        );
      }
    }

    // The header cart button is labelled with aria-label, so its count has to be
    // pushed there too — the visible <span> is aria-hidden and never reaches AT.
    // The separate live region (a sibling of the button, not a child — see
    // sections/header.liquid) is what actually announces the change.
    updateHeaderCartAnnouncement(cartData) {
      const count = cartData.item_count;
      const noun = count === 1 ? "item in cart" : "items in cart";

      const button = document.getElementById("cart-open-button");
      if (button) button.setAttribute("aria-label", `Cart ${count} ${noun}`);

      const live = document.querySelector("[data-header-cart-announcement]");
      if (live) live.textContent = `Cart: ${count} ${noun}`;
    }

    updateQuantityPriceElements(cartData) {
      const quantityPriceElements = document.querySelectorAll(
        "[data-line-item-quantity-price]"
      );

      quantityPriceElements.forEach((element) => {
        const lineItemKey = element.dataset.lineItemKey;
        const cartItem = cartData.items.find(
          (item) => item.key === lineItemKey
        );

        if (cartItem) {
          const quantity = cartItem.quantity;
          const unitPrice = cartItem.final_price;
          const formattedUnitPrice = this._formatMoney(
            unitPrice,
            KROWN.settings.shop_money_format
          );

          if (quantity > 1) {
            element.textContent = `(${quantity} x ${formattedUnitPrice})`;
            element.style.display = "";
          } else {
            element.style.display = "none";
          }
        }
      });
    }

    // New function to sync quantity inputs across all cart templates
    syncQuantityInputs(cartData) {
      // Update all quantity inputs with current cart data
      cartData.items.forEach((cartItem) => {
        const allCartItems = document.querySelectorAll("[data-js-cart-item]");
        allCartItems.forEach((item) => {
          if (item.dataset.id !== cartItem.key) return;

          const quantitySelector = item.querySelector("cart-product-quantity");

          // Skip sync if the user has a pending quantity change.
          // updateTimeout is null only between interactions (reset in debouncedUpdateCart).
          // If it's non-null, the user has already queued another change and we must
          // not overwrite their optimistic UI with the server's previous value.
          if (quantitySelector && quantitySelector.updateTimeout != null) {
            return;
          }

          const quantityInput = item.querySelector(
            ".qty, .br-cart-item__quantity-input"
          );
          if (
            quantityInput &&
            parseInt(quantityInput.value) !== cartItem.quantity
          ) {
            quantityInput.value = cartItem.quantity;
            item.dataset.qty = cartItem.quantity;

            if (
              quantitySelector &&
              typeof quantitySelector.updateButtonStates === "function"
            ) {
              quantitySelector.updateButtonStates();
            }
          }
        });
      });
    }

    _formatMoney(cents, format) {
      if (typeof cents === "string") {
        cents = cents.replace(".", "");
      }

      let value = "";
      const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      const formatString = format || "${{amount}}";

      function formatWithDelimiters(number, precision, thousands, decimal) {
        thousands = thousands || ",";
        decimal = decimal || ".";

        if (isNaN(number) || number === null) {
          return 0;
        }

        number = (number / 100.0).toFixed(precision);

        const parts = number.split(".");
        const dollarsAmount = parts[0].replace(
          /(\d)(?=(\d\d\d)+(?!\d))/g,
          "$1" + thousands
        );
        const centsAmount = parts[1] ? decimal + parts[1] : "";

        return dollarsAmount + centsAmount;
      }

      switch (formatString.match(placeholderRegex)[1]) {
        case "amount":
          value = formatWithDelimiters(cents, 2);
          break;
        case "amount_no_decimals":
          value = formatWithDelimiters(cents, 0);
          break;
        case "amount_with_comma_separator":
          value = formatWithDelimiters(cents, 2, ".", ",");
          break;
        case "amount_no_decimals_with_comma_separator":
          value = formatWithDelimiters(cents, 0, ".", ",");
          break;
        case "amount_no_decimals_with_space_separator":
          value = formatWithDelimiters(cents, 0, " ");
          break;
        case "amount_with_apostrophe_separator":
          value = formatWithDelimiters(cents, 2, "'");
          break;
        default:
          value = formatWithDelimiters(cents, 2);
      }

      return formatString.replace(placeholderRegex, value);
    }
  }

  if (typeof customElements.get("cart-form") == "undefined") {
    customElements.define("cart-form", CartForm);
  }
}

if (typeof CartProductQuantity !== "function") {
  class CartProductQuantity extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector(".qty");
      this.decreaseButton = this.querySelector(
        ".qty-minus, .quantity-decrease, .cart-item__quantity-decrease, .br-cart-item__quantity-decrease"
      );
      this.increaseButton = this.querySelector(
        ".qty-plus, .quantity-increase, .cart-item__quantity-increase, .br-cart-item__quantity-increase"
      );
      this.min = parseInt(this.input?.getAttribute("min")) || 1;
      this.max = parseInt(this.input?.getAttribute("max")) || 99;
      this.updateTimeout = null;
      this.originalValue = this.input ? this.input.value : "1";
      this.initialized = false;
      this.rapidTapMode = false;
      this.lastTapTime = null;
      this.isUpdating = false;

      if (this.input && this.decreaseButton && this.increaseButton) {
        this.init();
        this.initialized = true;
      }
    }

    init() {
      const newDecreaseButton = this.decreaseButton.cloneNode(true);
      const newIncreaseButton = this.increaseButton.cloneNode(true);

      if (this.decreaseButton.parentNode) {
        this.decreaseButton.parentNode.replaceChild(
          newDecreaseButton,
          this.decreaseButton
        );
        this.decreaseButton = newDecreaseButton;
      }

      if (this.increaseButton.parentNode) {
        this.increaseButton.parentNode.replaceChild(
          newIncreaseButton,
          this.increaseButton
        );
        this.increaseButton = newIncreaseButton;
      }

      this.decreaseButton.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation(); // Prevent event bubbling
        e.stopImmediatePropagation(); // Stop other handlers on same element
        this.changeQuantity(-1);
      });

      this.increaseButton.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation(); // Prevent event bubbling
        e.stopImmediatePropagation(); // Stop other handlers on same element
        this.changeQuantity(1);
      });

      const newInput = this.input.cloneNode(true);
      if (this.input.parentNode) {
        this.input.parentNode.replaceChild(newInput, this.input);
        this.input = newInput;
      }

      this.input.addEventListener("change", this.onInputChange.bind(this));
      this.input.addEventListener("keydown", (event) => {
        if (event.key === "ArrowUp") {
          event.preventDefault();
          this.changeQuantity(1);
        } else if (event.key === "ArrowDown") {
          event.preventDefault();
          this.changeQuantity(-1);
        }
      });

      this.updateButtonStates();
    }

    changeQuantity(change) {
      if (this.isUpdating) {
        return;
      }

      const now = Date.now();
      if (this.lastTapTime && now - this.lastTapTime < 100) {
        this.rapidTapMode = true;
      }
      this.lastTapTime = now;

      const currentValue = parseInt(this.input.value);
      let newValue = currentValue + change;

      if (change < 0 && currentValue === 1) {
        newValue = 0;
      } else {
        newValue = Math.max(this.min, Math.min(this.max, newValue));
      }

      if (newValue !== currentValue) {
        this.input.value = newValue;
        this.updateButtonStates();
        this.optimisticUIUpdate(newValue);

        if (newValue === 0) {
          const cartForm = document.querySelector("cart-form");
          const item = this.closest("[data-js-cart-item]");
          if (cartForm && typeof cartForm.updateCartQty === "function" && item) {
            this.isUpdating = true;
            this.classList.add("updating");
            cartForm
              .updateCartQty(item, 0)
              .then(() => {
                this.classList.remove("updating");
                this.isUpdating = false;
              })
              .catch(() => {
                this.classList.remove("updating");
                this.isUpdating = false;
              });
          }
        } else {
          this.debouncedUpdateCart();
        }
      }
    }

    optimisticUIUpdate(newQuantity) {
      const item = this.closest("[data-js-cart-item]");
      if (!item) return;

      const cartForm = document.querySelector("cart-form");
      if (!cartForm || typeof cartForm.paintLinePrices !== "function") return;

      // The unit price lives on the item element on BOTH templates. The drawer
      // used to carry no unit price at all, so this whole method bailed out and
      // its price never moved until the server replied.
      const unitPrice = parseInt(item.dataset.unitPrice);
      if (!Number.isFinite(unitPrice)) return;
      const compareUnitPrice = parseInt(item.dataset.compareUnitPrice);

      // Paint every copy of this line (the drawer is present on the cart page too),
      // snapshotting each so a failed request can put them all back.
      const copies = cartForm.itemsForKey(item.dataset.id);
      this.previousPrices = copies.map((copy) => {
        const priceEl = cartForm._priceEl(copy);
        const compareEl = cartForm._comparePriceEl(copy);
        return {
          copy,
          price: priceEl ? priceEl.textContent : null,
          compare: compareEl ? compareEl.textContent : null,
        };
      });

      copies.forEach((copy) => {
        cartForm.paintLinePrices(copy, newQuantity, unitPrice, compareUnitPrice);
        const priceEl = cartForm._priceEl(copy);
        if (priceEl) {
          priceEl.style.opacity = "0.6";
          setTimeout(() => {
            priceEl.style.opacity = "1";
          }, 300);
        }
      });
    }

    revertOptimisticUIUpdate() {
      if (!this.previousPrices) return;

      const cartForm = document.querySelector("cart-form");
      if (!cartForm) return;

      this.previousPrices.forEach(({ copy, price, compare }) => {
        const priceEl = cartForm._priceEl(copy);
        const compareEl = cartForm._comparePriceEl(copy);
        if (priceEl && price !== null) {
          priceEl.textContent = price;
          priceEl.style.opacity = "1";
        }
        if (compareEl && compare !== null) compareEl.textContent = compare;
      });
      this.previousPrices = null;
    }

    onInputChange(e) {
      // Add better input validation and prevent unwanted events
      e.stopPropagation();
      clearTimeout(this.updateTimeout);
      this.updateTimeout = setTimeout(() => {
        this.debouncedUpdateCart();
      }, 500);
    }

    updateButtonStates() {
      const value = parseInt(this.input.value);
      
      // FIXED: Never disable decrease button - allow removal at qty 1
      if (this.decreaseButton) {
        this.decreaseButton.disabled = false;
        this.decreaseButton.classList.remove("inactive");
        
        // Add visual feedback for remove mode when quantity is 1
        if (value === 1) {
          this.decreaseButton.classList.add("remove-mode");
        } else {
          this.decreaseButton.classList.remove("remove-mode");
        }
      }
      
      if (this.increaseButton) {
        this.increaseButton.disabled = value >= this.max;
        this.increaseButton.classList.toggle("inactive", value >= this.max);
      }
    }

    debouncedUpdateCart() {
      clearTimeout(this.updateTimeout);
      this.updateTimeout = setTimeout(() => {
        this.updateTimeout = null;
        this.updateCart();
      }, 200);
    }

    updateCart() {
      const cartForm = document.querySelector("cart-form");
      if (cartForm && typeof cartForm.updateCartQty === "function") {
        const item = this.closest("[data-js-cart-item]");
        if (item) {
          cartForm
            .updateCartQty(item, parseInt(this.input.value))
            .then(() => {
              this.classList.remove("updating");
              this.originalValue = this.input.value;
              this.previousPrices = null;
            })
            .catch(() => {
              // Put BOTH the quantity and the prices back — reverting only the
              // quantity left the line showing a price for a quantity the cart
              // never accepted.
              this.input.value = this.originalValue;
              this.updateButtonStates();
              this.revertOptimisticUIUpdate();
              this.classList.remove("updating");
            });
        }
      }
    }
  }

  if (typeof customElements.get("cart-product-quantity") == "undefined") {
    customElements.define("cart-product-quantity", CartProductQuantity);
  }
}

window.refreshCart = function (openDrawer = true) {
  document.body.classList.add("cart-updating");

  const announcer = document.querySelector(".cart-update-announcement");
  if (announcer) {
    announcer.textContent = KROWN.settings.locales.cart_updating || "Updating cart...";
  }

  fetch("/cart.js")
    .then((response) => response.json())
    .then((cartData) => {
      // Get the cart form instance for consistent updates
      const cartFormElement = document.querySelector("cart-form");

      if (cartData.item_count === 0) {
        const cartFormContainer = document.getElementById("AjaxCartForm");
        if (cartFormContainer) {
          cartFormContainer.innerHTML = `
            <div class="empty-cart-message">
              <p>${
                KROWN.settings.locales.cart_empty || "Your cart is empty"
              }</p>
            </div>
          `;
        }

        // Hide cart-footer-sidebar when cart is empty
        const cartFooterSidebar = document.querySelector('.cart-footer-sidebar');
        if (cartFooterSidebar) {
          cartFooterSidebar.style.display = 'none';
        }

        // Add cart--empty class to the sidebar cart footer for CSS to handle.
        // Scope to #site-cart-sidebar to avoid targeting the cart page's
        // duplicate .cart__footer element (duplicate #AjaxCartSubtotal IDs).
        const sidebarEl = document.getElementById('site-cart-sidebar');
        const cartFooter = sidebarEl
          ? sidebarEl.querySelector('.cart__footer')
          : document.querySelector('.cart__footer');
        if (cartFooter) {
          cartFooter.classList.add('cart--empty');
        }

        // Use consistent update methods if cart form exists
        if (
          cartFormElement &&
          typeof cartFormElement.updateCartCountElements === "function"
        ) {
          cartFormElement.updateCartCountElements({ items: [], item_count: 0 });
          cartFormElement.updateCartTotalElements({ total_price: 0 });
          cartFormElement.updateCartTextElements({ items: [], item_count: 0 });
        } else {
          // Fallback to direct updates
          const cartCountElements = document.querySelectorAll(
            "[data-header-cart-count], [data-cart-count]"
          );
          cartCountElements.forEach((elm) => {
            elm.textContent = "0";
          });

          const cartTotalElements = document.querySelectorAll(
            "[data-header-cart-total], [data-cart-total]"
          );
          cartTotalElements.forEach((elm) => {
            elm.textContent = "$0.00";
          });
        }

        document.body.classList.remove("cart-updating");

        if (announcer) {
          announcer.textContent = KROWN.settings.locales.cart_updated || "Cart updated";
          setTimeout(() => {
            announcer.textContent = "";
          }, 2000);
        }
      } else {
        fetch(`?section_id=${window.KT_FILE_PREFIX || ""}helper-cart`)
          .then((response) => response.text())
          .then((text) => {
            const sectionInnerHTML = new DOMParser().parseFromString(
              text,
              "text/html"
            );
            const cartFormInnerHTML =
              sectionInnerHTML.getElementById("AjaxCartForm").innerHTML;
            const cartSubtotalInnerHTML =
              sectionInnerHTML.getElementById("AjaxCartSubtotal").innerHTML;

            const cartItems = document.getElementById("AjaxCartForm");
            cartItems.innerHTML = cartFormInnerHTML;

            const cartForm =
              cartItems.closest("cart-form") ||
              document.querySelector("cart-form");
            if (cartForm && typeof cartForm.ajaxifyCartItems === "function") {
              cartForm.ajaxifyCartItems();
            }

            document.getElementById("AjaxCartSubtotal").innerHTML =
              cartSubtotalInnerHTML;

            // Ensure cart-footer-sidebar is visible when cart has items
            const cartFooterSidebar = document.querySelector('.cart-footer-sidebar');
            if (cartFooterSidebar) {
              cartFooterSidebar.style.display = '';
            }

            // Remove cart--empty class when cart has items.
            // Scope to sidebar to avoid the duplicate on the cart page.
            const sidebarElNonEmpty = document.getElementById('site-cart-sidebar');
            const cartFooterNonEmpty = sidebarElNonEmpty
              ? sidebarElNonEmpty.querySelector('.cart__footer')
              : document.querySelector('.cart__footer');
            if (cartFooterNonEmpty) {
              cartFooterNonEmpty.classList.remove('cart--empty');
            }

            // Use consistent update methods AFTER the innerHTML replacement
            if (
              cartFormElement &&
              typeof cartFormElement.updateCartCountElements === "function"
            ) {
              cartFormElement.updateCartCountElements(cartData);
              // cartFormElement.updateCartTotalElements(cartData);
              cartFormElement.updateCartTextElements(cartData);
              // cartFormElement.updateSubtotalElements(cartData);
            } else {
              // Fallback to direct updates
              const headerCartCount = document.querySelector(
                "[data-header-cart-count]"
              );
              const cartCount = cartItems.querySelector("[data-cart-count]");
              if (headerCartCount && cartCount) {
                headerCartCount.textContent = cartCount.textContent;
              }
            }

            const cartSidebar = document.getElementById("site-cart-sidebar");
            if (openDrawer === true && cartSidebar && typeof cartSidebar.show === "function") {
              cartSidebar.show(null);
            }

            const recommendations = document.querySelector("cart-recommendations");
            if (recommendations && typeof recommendations.generateRecommendations === "function") {
              recommendations.innerHTML = "";
              recommendations.generateRecommendations();
            }

            document.body.classList.remove("cart-updating");

            if (announcer) {
              announcer.textContent = KROWN.settings.locales.cart_updated || "Cart updated";
              setTimeout(() => {
                announcer.textContent = "";
              }, 2000);
            }

            // Dispatch cart-updated event for consistency
            const event = new CustomEvent("cart-updated", {
              bubbles: true,
              detail: {
                source: "refresh-cart",
                cartData: cartData,
              },
            });
            document.dispatchEvent(event);
          })
          .catch(() => {
            document.body.classList.remove("cart-updating");

            if (announcer) {
              announcer.textContent = KROWN.settings.locales.cart_error_updating || "Error updating cart";
              setTimeout(() => {
                announcer.textContent = "";
              }, 2000);
            }
          });
      }
    })
    .catch(() => {
      document.body.classList.remove("cart-updating");

      if (announcer) {
        announcer.textContent = KROWN.settings.locales.cart_error_updating || "Error updating cart";
        setTimeout(() => {
          announcer.textContent = "";
        }, 2000);
      }
    });
};

const cartStyles = `
  [data-js-cart-item] {
    transition: height 0.3s ease, opacity 0.3s ease;
  }

  [data-js-cart-item].item-updating {
    opacity: 0.6;
    pointer-events: none;
  }

  .empty-cart-message {
    text-align: center;
    padding: 40px 20px;
  }

  .empty-cart-message p {
    margin-bottom: 20px;
    font-size: 18px;
    color: #666;
  }
`;

if (!document.querySelector("#cart-component-styles")) {
  const styleSheet = document.createElement("style");
  styleSheet.id = "cart-component-styles";
  styleSheet.textContent = cartStyles;
  document.head.appendChild(styleSheet);
}

// Universal cart update listener
document.addEventListener("cart-updated", function (event) {
  const cartFormElement = document.querySelector("cart-form");

  // Only proceed if we have cart data and it's not from the cart form itself (to prevent loops)
  if (
    event.detail?.cartData &&
    event.detail?.source !== "cart-form" &&
    cartFormElement
  ) {
    const cartData = event.detail.cartData;

    // Use consistent update methods
    if (typeof cartFormElement.updateCartCountElements === "function") {
      cartFormElement.updateCartCountElements(cartData);
    }
    if (typeof cartFormElement.updateCartTotalElements === "function") {
      cartFormElement.updateCartTotalElements(cartData);
    }
    if (typeof cartFormElement.updateCartTextElements === "function") {
      cartFormElement.updateCartTextElements(cartData);
    }
    if (typeof cartFormElement.updateSubtotalElements === "function") {
      cartFormElement.updateSubtotalElements(cartData);
    }
    if (typeof cartFormElement.syncQuantityInputs === "function") {
      cartFormElement.syncQuantityInputs(cartData);
    }
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const quickViewButtons = document.querySelectorAll(
    "[data-js-quick-view-trigger]"
  );

  quickViewButtons.forEach((button) => {
    button.addEventListener("click", function (e) {
      e.preventDefault();

      const cartItem = button.closest("[data-js-cart-item]");
      if (!cartItem) return;

      const productId = cartItem.dataset.productId;
      if (!productId) return;

      button.classList.add("working");
      button.disabled = true;

      setTimeout(() => {
        button.classList.remove("working");
        button.disabled = false;
      }, 1000);
    });
  });
});

if ( ! customElements.get('cart-note') ) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();
        this.addEventListener(
          'input',
          debounce(event => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${KROWN.settings.routes.cart_update_url}`, {
							method: 'POST',
							headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
							body
						}).then(() => {
							KROWN.functions.dispatchStandardEvent('CartNoteUpdateEvent', this, {
								context: 'cart',
								note: event.target.value,
								promise: Promise.resolve({ cart: null })
							});
						});
		  		}, 300)
				);
      }
    }
  );
}

if ( ! customElements.get('cart-discounts' ) ) {
	customElements.define(
		'cart-discounts',
		class CartDiscounts extends HTMLElement {

			constructor() {

				super();

				const button = this.querySelector('[data-js-discount-submit]');
				this.input = this.querySelector('[data-js-discount-input]');
				this.cartSubtotal = document.getElementById('AjaxCartSubtotal');
				this.cartDiscountError = this.querySelector('[data-js-discount-error]');
				this.discountCodes = document.querySelector('[data-js-discount-codes]');
				this._prefix = window.KT_PREFIX || '';
				this.#loadDiscountButtons();

				button.addEventListener('click', (e) => {
					e.preventDefault();
					if ( this.input.value.length > 0 ) {

						this.cartSubtotal.classList.add(`${this._prefix}processing`);
						if (this.discountCodes) {
							this.discountCodes.classList.add(`${this._prefix}processing`);
						}

						const existingDiscounts = Array.from(this.querySelectorAll('[data-js-discount]')).map(elm => elm.dataset.jsDiscount);
						
						const allDiscounts = [...existingDiscounts, this.input.value];
						const discountString = allDiscounts.join(',');
						const body = JSON.stringify({ discount: discountString });

						fetch(`${KROWN.settings.routes.cart_update_url}`, { 
							method: 'POST',
							headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
							body 
						})
							.then(response => response.json())
							.then(response => {
								const discountCodes = response.discount_codes;
								const inputValue = this.input.value;
								const matchingCode = discountCodes.find(code => 
									code.code === inputValue
								);

								if (matchingCode) {
									if (matchingCode.applicable) {
										this.#handleSuccess();
									} else {
										this.#handleError();
									}
								} else {
									this.#handleError();
								}
							})
							.catch(error => {
								this.#handleError();
								console.log(`Error: ${error}`);
							})

					}

				});

			}

			#handleSuccess(){
				fetch(`?section_id=${window.KT_FILE_PREFIX || ''}helper-cart`)
					.then(response => response.text())
					.then(text => {
						const sectionInnerHTML = window.renderHelperCart(text);
						this.refreshDiscounts(sectionInnerHTML);
					})
					.catch(() => this.#handleError())
			}

			refreshDiscounts(sectionInnerHTML){

				this.cartSubtotal.classList.remove(`${this._prefix}processing`);
				this.cartDiscountError.innerHTML = '';
				this.input.value = '';

				const sectionDiscountCodes = sectionInnerHTML.querySelector('[data-js-discount-codes]');
				if ( this.discountCodes && sectionDiscountCodes ) {
					this.discountCodes.innerHTML = sectionDiscountCodes.innerHTML;
					this.discountCodes.classList.remove(`${this._prefix}processing`);
					this.#loadDiscountButtons();
				}

				const appliedDiscountCodes = sectionDiscountCodes
					? Array.from(sectionDiscountCodes.querySelectorAll('[data-js-discount]')).map(el => ({ code: el.dataset.jsDiscount }))
					: [];
				KROWN.functions.dispatchStandardEvent('CartDiscountUpdateEvent', this, {
					discountCodes: appliedDiscountCodes,
					promise: Promise.resolve({ cart: null })
				});
			}

			#loadDiscountButtons(){
				this.querySelectorAll('[data-js-discount]').forEach(elm=>{
					if ( ! elm.classList.contains(`${this._prefix}enabled`) ) {
						elm.classList.add(`${this._prefix}enabled`);
						elm.addEventListener('click', (e)=>{
							e.preventDefault();
							this.cartSubtotal.classList.add(`${this._prefix}processing`);
							if (this.discountCodes) {
								this.discountCodes.classList.add(`${this._prefix}processing`);
							}
							const discountToRemove = elm.dataset.jsDiscount;
							
							const allDiscountElements = this.querySelectorAll('[data-js-discount]');
							const allDiscounts = Array.from(allDiscountElements).map(el => el.dataset.jsDiscount);
							
							const remainingDiscounts = allDiscounts.filter(discount => discount !== discountToRemove);
							
							const body = JSON.stringify({ 
								discount: remainingDiscounts.join(',') 
							});
							
							fetch(`${KROWN.settings.routes.cart_update_url}`, { 
								method: 'POST',
								headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
								body 
							})
								.then(() => {
									this.#handleSuccess();
								})
								.catch(error => {
									console.error(`Error: ${error}`);
								});
						});
					}
				});
			}
			
			#handleError(){
				this.cartSubtotal.classList.remove(`${this._prefix}processing`);
				if (this.discountCodes) {
					this.discountCodes.classList.remove(`${this._prefix}processing`);
				}
				this.cartDiscountError.innerHTML = window.KROWN.settings.locales.cart_discount_code_error;
			}

		}	
	)
}
